export class GeneralSettingConfig {
    daysInAdvance: number;
    minRentalLength: number;
    maxRentalLength: number;

    constructor(){
        this.daysInAdvance = 0;
        this.minRentalLength = 0;
        this.maxRentalLength = 0;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/general-settings/general-setting.ts